// Route guard by role. Renders children only if the current user's role is allowed; otherwise
// bounces to the role home. (The nav already hides disallowed items — this defends direct URLs.)
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore.js';

export default function RoleRoute({ roles, children }) {
  const role = useAuthStore((s) => s.user?.role);
  if (!role) return null;
  if (!roles.includes(role)) return <Navigate to="/" replace />;
  return children;
}
